import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ee37b618"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "description-header-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "维护电池型号信息")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_form_page = _resolveComponent("form-page");
  const _directive_permission = _resolveDirective("permission");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(`${$data.edit ? '修改' : '增加'}电池型号`), 1)]), _hoisted_2]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formModel,
      rules: $data.formRules,
      class: "normal-form",
      ref: "formRef",
      "label-width": "160px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "电池型号",
        prop: "name"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formModel.name = $event),
          placeholder: "请输入电池型号"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "标准电压",
        prop: "standardVoltage"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.standardVoltage,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formModel.standardVoltage = $event),
          placeholder: "请输入标准电压"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "标准容量",
        prop: "standardCapacity"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.standardCapacity,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formModel.standardCapacity = $event),
          placeholder: "请输入标准容量"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "尺寸大小",
        prop: "modelSize"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.modelSize,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formModel.modelSize = $event),
          placeholder: "请输入尺寸大小"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "最小电压",
        prop: "minVoltage"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.formModel.minVoltage,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.formModel.minVoltage = $event),
          min: 0,
          precision: 2,
          placeholder: "请输入最小电压"
        }, null, 8, ["modelValue"]), _createTextVNode(" (V) ")]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "最大电压",
        prop: "maxVoltage"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.formModel.maxVoltage,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.formModel.maxVoltage = $event),
          min: 0,
          precision: 2,
          placeholder: "请输入最大电压"
        }, null, 8, ["modelValue"]), _createTextVNode(" (V) ")]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "最大行驶距离",
        prop: "maxMileage"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.formModel.maxMileage,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.formModel.maxMileage = $event),
          min: 0,
          placeholder: "请输入最大行驶距离"
        }, null, 8, ["modelValue"]), _createTextVNode(" (Km) ")]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: $options.submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("保存 ")]),
          _: 1
        }, 8, ["onClick"])), [[_directive_permission, ['batteryModel_add', 'batteryModel_edit']]]), _createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = () => {
            this.$router.go(-1);
          })
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  })]);
}